@if (queryKey() === undefined) {
<p class="pulse-dashboard-grid__hint">{{ 'Dashboard.Grid.NoQuery' | translate }}</p>
} @else if (state().status === 'error') {
<p class="pulse-dashboard-grid__hint">{{ 'Dashboard.Grid.Error' | translate }}</p>
} @else if (state().status === 'loading') {
<p class="pulse-dashboard-grid__hint">{{ 'Dashboard.Grid.Loading' | translate }}</p>
} @else { @let view = selectedView(); @let showSwitch = viewOptions().length > 1; @if (view &&
(view.title || view.description || showSwitch)) {
<div class="pulse-dashboard-grid__header">
    <div class="pulse-dashboard-grid__heading">
        @if (view.title) {
        <h3 class="pulse-dashboard-grid__title">{{ view.title }}</h3>
        } @if (view.description) {
        <p class="pulse-dashboard-grid__description">{{ view.description }}</p>
        }
    </div>
    @if (showSwitch) {
    <div class="pulse-dashboard-grid__filter">
        <!-- The switch below carries this text as its name so screen readers skip this copy. -->
        <span class="pulse-dashboard-grid__filter-label" aria-hidden="true">
            {{ switchHeading() }}
        </span>
        <pulse-segmented-toggle
            class="pulse-dashboard-grid__switcher"
            [value]="selectedViewId()"
            (valueChange)="selectedViewId.set($event)"
            [ariaLabel]="switchHeading()"
        >
            @for (option of viewOptions(); track option.id) {
            <button type="button" pulseSegmentedToggleItem [value]="option.id">
                {{ option.label }}
            </button>
            }
        </pulse-segmented-toggle>
    </div>
    }
</div>
}
<ag-grid-angular
    class="pulse-dashboard-grid__grid"
    [theme]="standardTheme"
    [modules]="modules"
    [rowData]="rowData()"
    [defaultColDef]="defaultColDef"
    [columnDefs]="columnDefs()"
    [context]="gridContext()"
    [localeText]="localeText()"
    [pagination]="paginate()"
    [paginationPageSize]="pageSize"
    [paginationPageSizeSelector]="false"
    [enableCellTextSelection]="true"
    [overlayNoRowsTemplate]="noRowsTemplate()"
/>
}
